import type { ComponentType } from 'react'

import type { BlogTableOfContentsItem } from '../types'
import InvoiceGeneratorToolPost, {
  slug as slug1,
  title as title1,
  description as description1,
  date as date1,
  image as image1,
} from './invoice-generator-tool'
import LegalBillInvoiceGeneratorPost, {
  slug as slug2,
  title as title2,
  description as description2,
  date as date2,
  image as image2,
} from './legal-bill-invoice-generator'
import InvoiceSoftwareForFreelancersPost, {
  slug as slug3,
  title as title3,
  description as description3,
  date as date3,
  image as image3,
  tableOfContents as tableOfContents3,
} from './invoice-software-for-freelancers'

export type { BlogTableOfContentsItem } from '../types'

export interface BlogPostMeta {
  slug: string
  title: string
  description: string
  date: string
  /** Header image URL (import from src/static/blog/ or use path if in public/blog/). */
  image?: string
  /** Optional in-page TOC (shown on desktop in a sticky side column). */
  tableOfContents?: BlogTableOfContentsItem[]
  Content: ComponentType
}

const posts: BlogPostMeta[] = [
  {
    slug: slug1,
    title: title1,
    description: description1,
    date: date1,
    image: image1,
    Content: InvoiceGeneratorToolPost,
  },
  {
    slug: slug2,
    title: title2,
    description: description2,
    date: date2,
    image: image2,
    Content: LegalBillInvoiceGeneratorPost,
  },
  {
    slug: slug3,
    title: title3,
    description: description3,
    date: date3,
    image: image3,
    tableOfContents: tableOfContents3,
    Content: InvoiceSoftwareForFreelancersPost,
  },
]

export function getPost(slug: string): BlogPostMeta | undefined {
  return posts.find((p) => p.slug === slug)
}

export function getAllPosts(): BlogPostMeta[] {
  return [...posts].sort((a, b) => (b.date > a.date ? 1 : -1))
}
